<template>
  <div class="row">
    <div class="col-lg-3"></div>
    <div class="col-lg-6 col-12">
      <div class="card mt-3 bg-white confirm-experience-card">
        <div>
          <div class="card-body color-grey-primary">
            <h3 class="color-primary header_border">
              CONFIRME SEU <strong>CURRÍCULO</strong>
            </h3>
            <Resume
              v-if="candidate_search"
              :id="candidate.id"
              :is_candidate="true"
              :resume="candidate.curriculum_text"
            />

            <Experiences :account_uid="account_uid" class="mb-4 mt-4" />
            <hr class="mt-4 mb-4" />

            <Educations
              :account_uid="account_uid"
              :job="job"
              class="mb-4 mt-4"
            />
            <hr class="mt-4 mb-4" />
            <ExtraCourses class="mb-4 mt-4" />
            <hr class="mt-4 mb-4" />
            <Certifications class="mb-4 mt-4" />
            <hr class="mt-4 mb-4" />
            <Skills
              ref="skillsForm"
              :account_uid="account_uid"
              class="mt-4 mb-4"
            />
            <hr />

            <Languages
              v-if="job.show_language"
              :candidate_id="candidate.id"
              url_custom="/candidates/languages"
            />

            <button
              class="btn btn-degrade full normal-degrade"
              type="button"
              @click="gotoQuestions"
            >
              <span v-show="!load">
                <span class="mr-3">Salvar</span>
                <font-awesome-icon icon="chevron-right" />
              </span>
              <div
                v-show="load"
                class="spinner-border text-light"
                role="status"
              ></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Resume from "@/Recruiters/TalentBank/Candidates/Resume.vue";
import Experiences from "@/Recruiters/TalentBank/Experiences/Index.vue";
import Educations from "@/Recruiters/TalentBank/Educations/Index.vue";
import ExtraCourses from "@/Recruiters/TalentBank/ExtraCourses/Index.vue";
import Certifications from "@/Recruiters/TalentBank/Certifications/Index.vue";
import Skills from "@/Recruiters/TalentBank/Skills/Form.vue";
import Languages from "@/Recruiters/TalentBank/Languages/Index.vue";

export default {
  components: {
    Resume,
    Experiences,
    Educations,
    Skills,
    Languages,
    ExtraCourses,
    Certifications,
  },

  props: ["account_uid", "job"],

  data: () => ({
    load: false,
    candidate_search: false,
    candidate: {},
    candidate_id: 0,
    educations: [],
    experiences: [],
    languages: [],
  }),
  async mounted() {
    // setTimeout(() => {
    await axios.get("/candidates/curriculum").then((response) => {
      this.candidate_search = true;
      this.candidate = response.data.candidate;
    });

    // }, 1000);
  },
  methods: {
    async gotoQuestions() {
      if (this.$refs.skillsForm.skills.length === 0) {
        this.$toast.error("Por favor, adicione pelo menos uma habilidade.");
        return;
      }
      await axios.get("/candidates/languages").then((response) => {
        this.languages = response.data.languages;
      });
      // if (this.languages.length == 0) {
      //   this.$toast.error("Preencha o idioma, click no botão para confirmar");
      //   return;
      // }
      if (this.load == true) return;
      this.load = true;
      let url = "/candidates/educations";
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/educations`;
      }
      axios.get(url).then((response) => {
        this.educations = response.data.educations;
        if (!this.validateEducations()) return;

        let url = "/candidates/experiences";
        if (this.candidate_id) {
          url = `/recruiters/talent_banks/${this.candidate_id}/experiences`;
        }
        axios.get(url).then((response) => {
          this.experiences = response.data.experiences;
          if (!this.validateExperiences()) return;
          axios
            .post("/candidates/reindex")
            .then((response) => {
              eventBus.$emit("ConfirmFinished", true);
            })
            .catch((error) => {
              this.load = false;
              this.$toast.error("Erro ao atualizar currículo");
            });

          // this.load = false;
          // this.$toast.error("Por favor, insira uma experiência acadêmica");
        });
      });
    },

    validateEducations() {
      let status = true;
      if (this.educations.length == 0) {
        this.$toast.error("Por favor, insira uma experiência acadêmica");
        this.load = false;
        return false;
      }
      if (this.educations.length > 0) {
        for (let i in this.educations) {
          if (this.educations[i].formation_type == null) {
            this.$toast.error(
              "Por favor, preencha o tipo de formação em todas as formações acadêmicas"
            );
            this.load = false;
            status = false;
          }
          if (
            !this.educations[i].city_id &&
            !this.educations[i].city_other_country
          ) {
            this.$toast.error(
              "Por favor, preencha a cidade em todas as formações acadêmicas"
            );
            this.load = false;
            status = false;
          }
          if (!this.educations[i].study_area_id) {
            this.$toast.error(
              "Por favor, preencha o curso em todas as formações acadêmicas"
            );
            this.load = false;
            status = false;
          }
          if (!this.educations[i].institution_id) {
            this.$toast.error(
              "Por favor, preencha a instituição em todas as formações acadêmicas"
            );
            this.load = false;
            status = false;
          }
          if (!this.educations[i].start_date) {
            this.$toast.error(
              "Por favor, preencha a data de início em todas as formações acadêmicas"
            );
            this.load = false;
            status = false;
          }
          if (
            !this.educations[i].end_date &&
            !this.educations[i].studying_here
          ) {
            this.$toast.error(
              "Por favor, preencha a data de término em todas as formações acadêmicas"
            );
            this.load = false;
            status = false;
          }
          if (
            this.job.require_formation_type &&
            this.educations[i].formation_type !== 0 &&
            !this.educations[i].formation_type
          ) {
            this.$toast.error(
              `O campo "Tipo de formação" não pode ficar vazio.`
            );
            this.load = false;
            return false;
          }

          if (
            this.job.require_scholarship &&
            this.educations[i].has_scholarship !== 0 &&
            !this.educations[i].has_scholarship
          ) {
            this.$toast.error(
              `O campo "Bolsas de estudos" não pode ficar vazio.`
            );
            this.load = false;
            return false;
          }

          if (
            this.job.require_average_point &&
            !this.educations[i].average_point &&
            this.educations[i].average_point !== 0
          ) {
            this.$toast.error(
              `O campo "Média na instituição" não pode ficar vazio.`
            );
            this.load = false;
            return false;
          }
        }
      }
      return status;
    },
    validateExperiences() {
      let status = true;
      if (this.experiences.length > 0) {
        for (let i in this.experiences) {
          if (this.experiences[i].occupation_id == null) {
            this.$toast.error(
              "Por favor, preencha o cargo em todos os históricos profissionais"
            );
            this.load = false;
            status = false;
          }
          if (!this.experiences[i].city_id) {
            this.$toast.error(
              "Por favor, preencha a cidade em todos os históricos profissionais"
            );
            this.load = false;
            status = false;
          }
          if (!this.experiences[i].company_id) {
            this.$toast.error(
              "Por favor, preencha a empresa em todos os históricos profissionais"
            );
            this.load = false;
            status = false;
          }
          if (!this.experiences[i].start_work) {
            this.$toast.error(
              "Por favor, preencha a data de início em todos os históricos profissionais"
            );
            this.load = false;
            status = false;
          }
          if (
            !this.experiences[i].end_work &&
            !this.experiences[i].current_job
          ) {
            this.$toast.error(
              "Por favor, preencha a data de término em todos os históricos profissionais"
            );
            this.load = false;
            status = false;
          }
        }
      }
      return status;
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .confirm-experience-card {
    margin-bottom: 200px;
  }
}
</style>
